/**
 * Decodes a base64url-encoded string using the browser-native atob().
 * Replaces the Node.js Buffer-based approach which is unavailable in browsers
 * since Webpack 5 removed automatic polyfills for Node.js core modules.
 * @param base64Url
 * @returns binary encoded url
 */
export function base64UrlSafeDecode(base64Url: string): string {
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padding = (4 - (base64.length % 4)) % 4;
    const padded = base64 + '='.repeat(padding);
    return atob(padded);
}
